import { TermsOfUse } from './index'

const routes = [
  {
    path: '/tou',
    name: 'Terms of Use',
    authenticated: false,
    render(props) {
      return <TermsOfUse {...props} />
    }
  }
]

export { routes }
